var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.97154 12.2425L8.02874 13.1853C6.72699 14.4871 4.61644 14.4871 3.31469 13.1853C2.01294 11.8836 2.01294 9.77305 3.31469 8.4713L4.2575 7.52849M12.7428 8.4713L13.6856 7.52849C14.9873 6.22674 14.9873 4.11619 13.6856 2.81445C12.3838 1.5127 10.2733 1.5127 8.97154 2.81445L8.02874 3.75725M6.16681 10.3332L10.8335 5.66655",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.089d563985fff01b26f9a77b932107dc.svg";
export { ForwardRef as ReactComponent };